import { render, staticRenderFns } from "./Prosafety.vue?vue&type=template&id=644c3806&"
import script from "./Prosafety.vue?vue&type=script&lang=js&"
export * from "./Prosafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports